import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import axios from 'axios';
import { Col, ControlLabel, Form, Button, FormGroup, Checkbox, Modal } from 'react-bootstrap';
import config from '../../config/config';

const appUrlPath = `/${config.appUrlPath}`;

export class CreateNewQuotation extends Component {
  constructor(props) {
    super(props);
    const role = localStorage.getItem('role');
    const isPV = localStorage.getItem('isPV');
    const isCV = localStorage.getItem('isCV');
    let quotationTypeArray = [];
    let quotationType = '';
    const admin = [
      { code: 'pv', name: 'SMARTDRIVE PRIVATE CAR' },
      { code: 'cv', name: 'SMARTDRIVE COMMERCIAL VEHICLE' }
    ];
    const pv = [
      { code: 'pv', name: 'SMARTDRIVE PRIVATE CAR' }
    ];
    const cv = [
      { code: 'cv', name: 'SMARTDRIVE COMMERCIAL VEHICLE' }
    ];
    if (role === 'admin' || (isPV === 'true' && isCV === 'true')) {
      quotationTypeArray = admin;
      quotationType = 'pv';
    } else if (isPV === 'true') {
      quotationTypeArray = pv;
      quotationType = 'pv';
    } else if (isCV === 'true') {
      quotationTypeArray = cv;
      quotationType = 'cv';
    }

    this.state = {
      redirect: false,
      quotationType,
      checkbox: false,
      quotationTypeArray,
      showModal: false,
      errorMsg: ''
    };

    this.handleChangeQuotationType = this.handleChangeQuotationType.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeCheckbox = this.handleChangeCheckbox.bind(this);
    this.close = this.close.bind(this);

    axios.get(`${appUrlPath}/getCsrfToken`, {
      params: {},
      headers: { 'ACTION-LOG': 'Access Create New Quotation Page' }
    })
    .then((res) => {
      axios.defaults.headers.common = {
        'CSRF-TOKEN': res.data.csrfToken
      };
    })
    .catch(() => {
    });
  }

  componentWillMount() {

  }

  close() {
    this.setState({ showModal: false });
  }

  handleChangeQuotationType(e) {
    this.setState({
      quotationType: e.target.value
    });
  }

  handleChangeCheckbox(e) {
    this.setState({
      checkbox: e.target.checked
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    if (!this.state.checkbox) {
      this.setState({ showModal: true, errorMsg: 'Agree the declaration first' })
      return;
    }
    if (this.state.quotationType === 'pv') {
      browserHistory.push({
        pathname: `/en${appUrlPath}/pvform`,
        state: {
          'isAgree': this.state.checkbox
        }
      });
    } else {
      browserHistory.push({
        pathname: `/en${appUrlPath}/cvform`,
        state: {
          'isAgree': this.state.checkbox
        }
      });
    }
  }

  handleClick() {
    window.location.assign(`/en${appUrlPath}/home`);
  }

  render() {
    const downloadTnC = `${appUrlPath}/downloadTnC`;
    const downloadPersonalInformationCollection = `${appUrlPath}/downloadPersonalInformationCollection`;
    const downloadPrivacyPolicyStatement = `${appUrlPath}/downloadPrivacyPolicyStatement`;
    const downloadDeclarationCV = `${appUrlPath}/downloadDeclarationCV`;
    const downloadDeclarationPV = `${appUrlPath}/downloadDeclarationPV`;
    const downloadPolicyWordingCV = `${appUrlPath}/downloadPolicyWordingCV`;
    const downloadPolicyWordingPV = `${appUrlPath}/downloadPolicyWordingPV`;
    return (
      <div>
      {this.state.showModal ?
        <Modal.Dialog>
          <Modal.Header>
            <Modal.Title>Warning</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.errorMsg}
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.close}>OK</Button>
          </Modal.Footer>
        </Modal.Dialog> : null}
       <h2 className="ebaoUtil__HeaderTwo">New Quotation</h2>
       <Form horizontal onSubmit={this.handleSubmit}>
          <div className="ebaoUtil__Form">
            <FormGroup controlId="quotationType">
                  <Col componentClass={ControlLabel} sm={4}>
                    Please select the Product:
                  </Col>
                  <Col sm={8}>
                    <select className="custom-select" onChange={this.handleChangeQuotationType}>
                      { this.state.quotationTypeArray.map((obj, index) => {
                        const counter = index;
                        return (
                          <option
                            value={obj.code}
                            key={counter}
                          >{obj.name}</option>
                        );
                      }) }
                    </select>
                  </Col>
            </FormGroup>
            {this.state.quotationType === 'pv' ?
              <FormGroup>
                <Col sm={12}>
                  <h3 className="CreateNewQuotation__Header CreateNewQuotation__RedInColor">Risks To Be Referred to AXA General Insurance Hong Kong Limited</h3>
                  <h3 className="CreateNewQuotation__SubHeader CreateNewQuotation__Spacing CreateNewQuotation__RedInColor">(In the event that a driver fits one or more of the categories listed below, do not use this system for a quotation and contact your account executive)</h3>
                  <h3 className="CreateNewQuotation__Header CreateNewQuotation__RedInColor">Referred Drivers</h3>
                  <ul className="CreateNewQuotation__ListStyle CreateNewQuotation__RedInColor CreateNewQuotation__ListStyleType">
                    <li>Driver below the age of 25 years old</li>
                    <li>Driver with less than 2 years of driving experience</li>
                    <li>Driver with more than 12 driving offence points in the past 24 months</li>
                    <li>Driver with any motor claim within 3 years</li>
                  </ul>
                </Col>
              </FormGroup> :
              <FormGroup>
                <Col sm={12}>
                  <h3 className="CreateNewQuotation__Header CreateNewQuotation__RedInColor">Risks To Be Referred to AXA General Insurance Hong Kong Limited</h3>
                  <h3 className="CreateNewQuotation__SubHeader CreateNewQuotation__Spacing CreateNewQuotation__RedInColor">(In the event that the risk fits one or more of the categories listed below, do not use this system for a quotation and contact your account executive)</h3>
                  <h4 className="CreateNewQuotation__Header CreateNewQuotation__RedInColor ebaoUtil__Bold-Underline-Text">Referred Risks</h4>
                  <ul className="CreateNewQuotation__ListStyle CreateNewQuotation__ListStyleType">
                    <li>Trade - Rental / Leasing</li>
                    <li>Risks with loss suffered or claim incurred in the last 3 years</li>
                    <li>Proposer / Driver below the age of 25 years old</li>
                    <li>Proposer / Driver exceeding the age of 65 years old</li>
                    <li>Proposer / Driver with less than 2 years driving experience</li>
                  </ul>
                  <h4 className="CreateNewQuotation__Header CreateNewQuotation__RedInColor ebaoUtil__Bold-Underline-Text">Declined Risks</h4>
                  <ul className="CreateNewQuotation__ListStyle CreateNewQuotation__ListStyleType">
                    <li>Vehicles transporting dangerous or inflammable goods</li>
                    <li>Related to newspaper delivery services</li>
                    <li>Carrying passengers for hire or reward</li>
                    <li>Tractor, Trailer, Tipper, Dump Truck, Coach, Public/Private Light Bus, Taxi</li>
                    <li><span className="ebaoUtil__Bold-Underline-Text">Individual</span> Proposer who is not holding a valid Hong Kong relevant driving license</li>
                  </ul>
                  <h4 className="CreateNewQuotation__Header CreateNewQuotation__RedInColor ebaoUtil__Bold-Underline-Text">Referred Vehicle</h4>
                  <ul className="CreateNewQuotation__ListStyle CreateNewQuotation__ListStyleType">
                    <li>Vehicles &gt; 24 tons</li>
                    <li>Vehicle exceeding 20 years</li>
                  </ul>
                </Col>
              </FormGroup>
            }
            <FormGroup>
            <Col componentClass={ControlLabel} sm={1}>
            <Checkbox
              checked={this.state.checkbox}
              onClick={this.handleChangeCheckbox} />
            </Col>
              <Col sm={11}>
              By checking this box, I confirm that the proposer and/or each named driver(s) have read, understood and agreed with: (1) the declarations (<b><a target="_blank" rel="noopener noreferrer" href={downloadDeclarationPV}>Private Car</a></b> or <b><a target="_blank" rel="noopener noreferrer" href={downloadDeclarationCV}>Commercial Vehicle</a></b>, as the case may be), policy terms, conditions and exclusions (<b><a target="_blank" rel="noopener noreferrer" href={downloadPolicyWordingPV}>Private Car</a></b> or <b><a target="_blank" rel="noopener noreferrer" href={downloadPolicyWordingCV}>Commercial Vehicle</a></b>, as the case may be) , <a target="_blank" rel="noopener noreferrer" href={downloadPersonalInformationCollection}>Personal Information Collection Statement</a> as well as the <a target="_blank" rel="noopener noreferrer" href={downloadPrivacyPolicyStatement}>Privacy Policy</a>; (2) AXA will contact the proposer directly or via the intermediary as per the correspondence option selected, merely by electronic means; and (3) proposer and/or all named driver(s) meet the following criteria: a) have not been refused insurance, or have not had it terminated, or have not been refused a quotation, b) have not had their license suspended or revoked in the past 2 years, and c) with less than 12 driving offence points accumulated in the past 2 years. By checking this box, I also agree to the <a target="_blank" rel="noopener noreferrer" href={downloadTnC}>Terms and Conditions for Access to or Use of the System</a>.
              </Col>
            </FormGroup>
             <FormGroup controlId="buttonGroup">
               <div className="ebaoUtil__ButtonGroup">
                 <button type="submit" className="btn btn-axa">Continue</button>{' '}
                 <button type="button" className="btn btn-axa" onClick={this.handleClick}>Exit</button>
               </div>
             </FormGroup>
          </div>
       </Form>
    </div>
    )
  }
}

export default CreateNewQuotation;



// WEBPACK FOOTER //
// ./src/app/pages/CreateNewQuotation.js